import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PDFViewer from '../Files/documents/PDFViewer';
import Skeleton from './TailwindComponents/Skeleton';

interface FileReaderComponentProps {
  fileUrl: string;
  fileType: string;
}

const FileReaderComponent: React.FC<FileReaderComponentProps> = ({ fileUrl, fileType }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [viewerUrl, setViewerUrl] = useState<string | null>(null);

  useEffect(() => {
    const processFile = () => {
      const lowerFileType = fileType.toLowerCase();

      if (lowerFileType.includes('pdf')) {
        setViewerUrl(fileUrl);
      } else if (lowerFileType.includes('image')) {
        setViewerUrl(fileUrl);
      } else if (lowerFileType.includes('word') || lowerFileType.includes('doc')) {
        setViewerUrl(`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`);
      } else {
        setViewerUrl(fileUrl);
      }
      setIsLoading(false);
    };
    processFile();
  }, [fileUrl, fileType]);

  if (isLoading) {
    if (fileType.toLowerCase().includes('pdf')) {
      return <Skeleton variant="document" />;
    } else if (fileType.toLowerCase().includes('image')) {
      return <Skeleton variant="prose" rows={6} />;
    } else {
      return <div className="animate-fadePulse h-64 bg-gray-200 dark:bg-gray-700 rounded"></div>;
    }
  }

  return (
    <div className="h-[calc(100vh-200px)] min-w-[calc(100vw-200px)] mx-auto mt-6">
      {fileType.toLowerCase().includes('pdf') ? (
        <PDFViewer pdfUrl={viewerUrl!} />
      ) : fileType.toLowerCase().includes('image') ? (
        <img src={viewerUrl!} alt={t('Attachment')} className="max-w-full h-auto" />
      ) : (
        <iframe
          src={viewerUrl!}
          title={t('Document viewer')}
          className="w-full h-full"
          frameBorder="0"
        />
      )}
    </div>
  );
};

export default FileReaderComponent;